export function presentAdjustSum(adjust) {
  if (adjust === '0') return adjust;
  
  const isPositive = adjust.startsWith('-');
  const presentValue = isPositive ? adjust.substring(1) : '-' + adjust;
  return presentValue;
}